<template>

  <ContentWrapper>    
    <SectionHeader subheader="Platform Overview" title="A comprehensive solution for running your events" isCentered="true" class="mt-32 mb-24"/>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-0 md:gap-2 ">
      <router-link :to="feature.comingSoon ? '#' : feature.link" v-for="feature in platformFeatures" :key="feature.id" class="flex flex-col items-center text-center cursor-pointer group hover:bg-blue-50 p-4 rounded-lg transition-colors">
        <div class="mb-3">
          <Icon :icon="feature.icon" variant="primary" />
        </div>
        <h3 class="font-headings text-lg group-hover:text-primary-500">{{ feature.name }} <span v-if="feature.comingSoon" class="text-gray-500 text-xs ml-4">Coming Soon</span></h3>
        <p class="text-sm text-gray-600">{{ feature.description }}</p>
      </router-link>
    </div>
  </ContentWrapper>

  <SectionHeader subheader="How it Works" title="A step by step guide to running your event" isCentered="true" class="mt-32 mb-0"/>

  <EventTimeline />
</template>

<script setup>
import { ref } from 'vue'
import { platformFeatures } from '@/router/features'
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'
import Icon from '@/components/Buttons/Icon.vue'
import SectionHeader from '@/components/Layouts/SectionHeader.vue'
import EventTimeline from '@/components/Sections/EventTimeline.vue'


</script>

<style scoped>
/* Additional custom styles if needed */
</style>
